import axios from '@axios';
import _ from 'lodash';

export function importCsv(data, options) {
    let formData = new FormData();
    formData.append('files.files', data);
    formData.append('data', JSON.stringify({ strapi: true }));
    return axios.post('/faqs/import-csv', formData, options);
}
